export const VIEW_ALL_OPTION_ID = 'view-all';

export const FEATURED_OPTION_ID = 'featured';
